import Verte from "verte";
import "verte/dist/verte.css";
import Vue from "vue";

Vue.component(Verte.name, Verte);
